import { Component, EventEmitter, Output, ViewEncapsulation } from '@angular/core';
import { Store } from '@ngrx/store';
import { EntityRegisterView } from 'src/app/common-components/register/models/register-view';
import { FaxOrderingOptions, FaxRegisterOptions } from '../../models/fax-register-options';
import { FaxRegisterListItem } from '../../models/fax-register-results.model';
import { FaxStatusOption } from '../../models/fax-status-option.interface';
import { FaxTypeOption } from '../../models/fax-type-option.interface';
import { FaxRegisterApiService } from '../../services/fax-register-api.service';
import { selectQuickFilters } from '../state/incoming-fax-register.reducer';

@Component({
    encapsulation: ViewEncapsulation.None,
    selector: 'ndt-incoming-fax-register-view',
    styleUrls: ['./incoming-fax-register-view.component.scss'],
    templateUrl: './incoming-fax-register-view.component.html',
    standalone: false
})
export class IncomingFaxRegisterViewComponent extends EntityRegisterView<
   FaxRegisterListItem,
   FaxRegisterOptions,
   FaxOrderingOptions
> {
   protected selectQuickFilters(): (state: object) => FaxRegisterOptions | null {
      return selectQuickFilters;
   }
   constructor(public store: Store, private faxRegisterApiService: FaxRegisterApiService) {
      super(store);
   }
   selectedFaxType: FaxTypeOption | undefined = undefined;

   selectedFaxStatus: FaxStatusOption | undefined = undefined;

   @Output() openDialog = new EventEmitter<{ faxLogs: any }>();

   onOpenDialog(faxLogs: any) {
      this.openDialog.emit({ faxLogs: faxLogs });
   }

   onFilterChange(filterValues: { startDate: Date; endDate: Date }) {
      const { startDate, endDate } = filterValues;
      this.registerOptions = { ...this.registerOptions, endDate, startDate };
      this.quickFilterChange.emit(this.registerOptions);
   }
   getRouterLink(id: number) {
      return `${id}`;
   }
   onFaxTypeSelected(faxType: FaxTypeOption) {
      this.registerOptions = { ...this.registerOptions, typeName: faxType };
      this.quickFilterChange.emit(this.registerOptions);
   }
   onFaxStatusSelected(faxStatus: FaxStatusOption) {
      this.registerOptions = { ...this.registerOptions, statusName: faxStatus };
      this.quickFilterChange.emit(this.registerOptions);
   }
   downloadFile(fileToken: string, fileName: string): void {
      this.faxRegisterApiService.downloadFile(fileToken, fileName);
   }
}
